/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DevicesBulkAssignmentTenantResponseDto } from './DevicesBulkAssignmentTenantResponseDto';
import type { FileResponseDto } from './FileResponseDto';
import type { FileUploadResponseDto } from './FileUploadResponseDto';
export type TenantDevicesBulkAssignmentResponseDto = {
  id: number;
  tenant: DevicesBulkAssignmentTenantResponseDto;
  status: TenantDevicesBulkAssignmentResponseDto.status;
  createdBy: string;
  updatedAt: string;
  createdAt: string;
  file?: FileResponseDto;
  fileUpload?: FileUploadResponseDto;
};
export namespace TenantDevicesBulkAssignmentResponseDto {
  export enum status {
    NEW = 'NEW',
    ENDED = 'ENDED',
    ERROR = 'ERROR',
  }
}

